// How a seat and a +1 guest are worded to the participant. Shared by every view
// that shows the Seating store (the stage profile panel and the profile page),
// so the same seat never reads differently depending on where it is opened.
export default {
  methods: {
    // The organizer names the place themselves ("Table 4", "Balcony"), so it is
    // printed as given rather than prefixed with a word of our own.
    seatText(seat) {
      const location = seat?.locationName;
      const number = seat?.seatNumber;

      if (!location && !number) {
        return this.$t('Views.Stage.MyProfile.seatingNotAvailable');
      }

      const parts = [];
      if (location) {
        parts.push(location);
      }
      if (number) {
        parts.push(`${this.$t('Views.Stage.MyProfile.seat')} ${number}`);
      }

      return parts.join(' · ');
    },
    // A +1 bought as an extra ticket carries a name only if the buyer filled one
    // in, so unnamed guests are numbered in the order the organizer sees them.
    guestName(guest, index) {
      return (
        guest?.name || `${this.$t('Views.Stage.MyProfile.guest')} ${index + 1}`
      );
    }
  }
};
